export function formatarNumero(numeroFormatado: string) {
  const numeroSemMoeda = numeroFormatado.replace('R$', '')
  const numeroSemPontos = numeroSemMoeda.replace(/\./g, '')
  const numeroComPonto = numeroSemPontos.replace(',', '.')
  return parseFloat(numeroComPonto).toFixed(2)
}
